import React from 'react';
import AppContext from 'components/appContext';
import MsgBox from 'sis_ui/modules/notifications';
import {withTranslation} from "react-i18next";
class PortalNotification extends React.Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);
    }

    _getPortal() {
        let portal = '';

        switch(this.props.portal) {
            case 'TRAINEE':
                portal = this.props.t("lbl.TRAINEE",'Trainee'); 
                break;
            case 'SUPERVISOR':
                portal = this.props.t("lbl.SUPERVISOR",'Supervisor');
                break;
        }
        return portal;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.show != this.props.show && this.props.show) {
            MsgBox.drawMessage('info',this.props.t("lbl.LOGGED_IN_AS",{USER_ROLE:this._getPortal()}),{
                onClose: this.handleClose.bind(this),
            } )
        }
    }

    handleClose(){
        this.context.set('showCurrentPortalInfo', false);
    }

    render() {
        return "";
    }
}

export default withTranslation()(PortalNotification);